module.exports = __webpack_public_path__ + "img/gift4-01-c01-y2.8166eb8f.png";